module.exports = __webpack_public_path__ + "static/media/organization.6b9c8ca2.png";